import { AppTableControls } from 'common/TableControls/TableControls';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import type { MunicipalityWithRegion } from 'services/api';

export const getMunicipalitiesTableColumns = (
  edit: (id: number) => void,
  remove: (id: number) => void,
): AppTableColumn<MunicipalityWithRegion>[] => {
  const columns: AppTableColumn<MunicipalityWithRegion>[] = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: ['id'],
      maxWidth: '5rem',
    },
    {
      key: 'name',
      title: 'Название муниципалитета',
      dataIndex: ['name'],
      maxWidth: '25rem',
    },
    {
      key: 'regionName',
      title: 'Регион',
      dataIndex: ['regionName'],
      maxWidth: '25rem',
    },
  ];

  columns.push({
    key: 'controls',
    title: '',
    dataIndex: [],
    maxWidth: '5rem',
    render: (value: any, record: MunicipalityWithRegion) => {
      return <AppTableControls edit={() => edit(record.id)} remove={() => remove(record.id)} />;
    },
  });

  return columns;
};
